import { saveAs } from 'file-saver'

export const saveConfigYamlFile = (fileContent) => {
  // @ts-ignore
  const blob = new Blob([fileContent], {
    type: 'text/plain;charset=utf-8',
  })
  saveAs(blob, `spectral.yaml`)
}
